(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      document.documentElement.style.setProperty('--announcement-height', `${announcementBar.offsetHeight}px`);

      window.addEventListener('scroll', function () {
        if (window.scrollY === 0) {
          document.documentElement.style.setProperty('--announcement-height', `${announcementBar.offsetHeight}px`);
        }
        else {
          document.documentElement.style.setProperty('--announcement-height', `${Math.max(0, announcementBar.offsetHeight - window.scrollY)}px`);
        }
      });

      window.dispatchEvent(new Event('scroll'));
    } else {
      document.documentElement.style.setProperty('--announcement-height', '0px');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hotspots-tabbed"] && !Shopify.designMode) return;
  try {
    
  /* Theme editor only.

     Changing any setting re-renders the whole section, and the server-rendered
     markup always marks the FIRST look as visible. Editing a hotspot inside
     look 2 or 3 therefore threw you back to look 1 on every keystroke.

     This remembers which panel was open per section and restores it after a
     re-render, and follows the merchant's block selection so clicking a look
     (or a hotspot inside one) opens the right tab. Storefront behaviour is
     unchanged — the whole thing is behind Shopify.designMode. */
  (function () {
    if (!window.Shopify || !Shopify.designMode) return;

    var remembered = {};

    function sectionIdOf(el) {
      var section = el.closest && el.closest('.shopify-section');
      return section ? section.id : null;
    }

    /* Click the tab that owns this panel and let tabs.js do the switching, so
       there is only one implementation of "show this panel". */
    function activatePanel(panel) {
      if (!panel) return;

      var root = panel.closest('.hotspot-tabs');
      if (!root) return;

      var tabs = root.querySelectorAll('.hotspot-tabs__tab');

      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].getAttribute('aria-controls') !== panel.id) continue;
        if (tabs[i].getAttribute('aria-selected') !== 'true') tabs[i].click();
        return;
      }
    }

    /* Remember whatever the merchant opens by hand. Capture phase, so it still
       records if something downstream stops propagation. */
    document.addEventListener(
      'click',
      function (event) {
        var tab = event.target.closest && event.target.closest('.hotspot-tabs__tab');
        if (!tab) return;

        var id = sectionIdOf(tab);
        if (id) remembered[id] = tab.getAttribute('aria-controls');
      },
      true
    );

    /* A look, a hotspot inside a look, or a sticker was selected in the editor.
       Stickers get relocated outside .hotspot-tabs by their own script, so they
       resolve to no panel and are correctly ignored. */
    document.addEventListener('shopify:block:select', function (event) {
      var panel = event.target.closest && event.target.closest('.hotspot-tabs__panel');
      if (!panel) return;

      var id = sectionIdOf(panel);
      if (id) remembered[id] = panel.id;

      requestAnimationFrame(function () {
        activatePanel(panel);
      });
    });

    /* Section re-rendered. Block ids survive a re-render, so the remembered
       panel id still resolves. */
    document.addEventListener('shopify:section:load', function (event) {
      var want = remembered[event.target.id];
      if (!want) return;

      requestAnimationFrame(function () {
        activatePanel(document.getElementById(want));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
